<template>
    <adaptive-form-modal
        name="add-edit-milestone"
        :method="formMethod"
        :primary-button-text="formActionText"
        primary-button-class="is-primary"
        :title="formActionText"
        :action="actionUrl"
        :callback="savedCallback"
        @before-open="beforeOpen"
    >
        <text-input
            label="Namn"
            name="name"
            :value="name"
            :maxlength="40"
            :required="true"
            :autofocus="true"
        />

        <text-input
            label="Datum"
            type="date"
            name="date"
            :value="date"
            :required="true"
        />
    </adaptive-form-modal>
</template>

<script>
    import { format } from 'date-fns';

    export default {
        props: {
            project: {
                required: true,
                type: Object,
            },
        },

        data() {
            return {
                milestone: null,
                name: null,
                date: null,
                edit: false,
            };
        },

        computed: {
            formMethod() {
                return this.edit ? 'patch' : 'post';
            },
            formActionText() {
                return this.edit ? 'Uppdatera delmål' : 'Lägg till delmål';
            },
            actionUrl() {
                return this.edit
                    ?  route('api.sales-projects.milestones.update', [this.project, this.milestone.id])
                    : route('api.sales-projects.milestones.store', this.project);
            },
        },

        methods: {
            beforeOpen(event) {
                // Reset data between form opens
                this.milestone = null;
                this.name = null;
                this.date = format(new Date(), 'YYYY-MM-DD'); // Default date
                this.edit = false;

                if (event.params) {
                    this.milestone = event.params.milestone;
                    this.name = this.milestone.name;
                    this.date = this.milestone.date;
                    this.edit = true;
                }
            },

            savedCallback(response) {
                this.$modal.hide('add-edit-milestone');
                this.$emit('milestonesChanged', response.data);
            },

        },
    };
</script>
